@if (tableColumns().length) {
    <div fxFlex="grow">
        <app-data-list-command
            [filters]="filters()"
            [(filtersToApply)]="filtersToApply"
            sidenavclass="p-t-3xl"
            [loading]="isLoading()">
            <!-- This is the command left part (add button, global filters, actions) -->
            <ng-content select="[commandHeader]"></ng-content>

            <div cipoCommandContent class="cipo--height--full" fxLayout="column">
                @if (errorMessage()) {
                    <p class="cipo-text--warn-500 m-a-sm" [innerHTML]="errorMessage() | translate | safeHtml"></p>
                }
                @if (viewType() === DATA_LIST_TYPE.Card) {
                    <app-data-cards-view
                        class="cipo--overflow--auto cipo--height--full"
                        [screentype]="screenTypeEnum.Card"
                        [actions]="cardActions()"
                        [rows]="$any(items())"
                        [(options)]="tableOptions"
                        [isLoading]="isLoading()"
                        (cardclick)="cardClicked.emit($event)"
                        (paginationUpdated)="onPaginationUpdated($event)" />
                } @else if (viewType() === DATA_LIST_TYPE.Module) {
                    @if (gridstackHeaderItems()?.length) {
                        <cipo-gridstack-header
                            fxFlex="none"
                            [headerItems]="gridstackHeaderItems()"
                            [data]="gridstakHeaderData()" />
                    }
                    @if (!tableOptions().onlyPaged && isInfiniteScroll()) {
                        <cipo-infinite-data-list
                            fxFlex="grow"
                            class="cipo--overflow--auto"
                            [tableColumns]="tableColumns()"
                            [tableData]="items()"
                            [updatedRows]="updatedRows()"
                            [(options)]="tableOptions"
                            [loading]="isLoading()"
                            [footerRows]="tableFooterRows()"
                            (rowClicked)="actionSelected.emit({ actionId: rowClickActionId, data: $event })"
                            (actionSelected)="actionSelected.emit($event)"
                            [selection]="selection()"
                            (paginationUpdated)="onPaginationUpdated($event)"
                            (sortChanged)="onSortChanged($event)"></cipo-infinite-data-list>
                    } @else {
                        <cipo-paged-data-list
                            fxFlex="grow"
                            class="cipo--overflow--auto"
                            [tableColumns]="tableColumns()"
                            [tableData]="items()"
                            [updatedRows]="updatedRows()"
                            [(options)]="tableOptions"
                            [footerRows]="tableFooterRows()"
                            (rowClicked)="actionSelected.emit({ actionId: rowClickActionId, data: $event })"
                            (actionSelected)="actionSelected.emit($event)"
                            [selection]="selection()"
                            (paginationUpdated)="onPaginationUpdated($event)"
                            (sortChanged)="onSortChanged($event)"></cipo-paged-data-list>
                    }
                } @else if (viewType() === DATA_LIST_TYPE.Calendar) {
                    <app-calendar-view
                        [actions]="calendarActions()"
                        [search]="searchParams()"
                        [(isLoading)]="isLoading"
                        (eventClicked)="calendarEventClicked.emit($event)" />
                } @else if (viewType() === DATA_LIST_TYPE.Gantt) {
                    <cipo-gantt-view
                        fxFlex="grow"
                        class="cipo--overflow--auto"
                        [contractId]="contractId()"
                        [moduleId]="moduleId()"
                        [search]="searchParams()"
                        [gridFields]="ganttGridFields()"
                        [dataReloadToken]="ganttDataReloadToken()"
                        [actions]="calendarActions()"
                        [(errorMessage)]="errorMessage"
                        [(isLoading)]="isLoading" />
                }
            </div>
        </app-data-list-command>
    </div>
} @else {
    <div fxLayoutAlign="center center" class="cipo--width--full">
        <mat-spinner diameter="100"></mat-spinner>
    </div>
}
